/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { fetchDrivers } from "../services/driver.service";
import {
  Stack,
  Grid,
  Loading,
  Button,
  Box,
  Heading,
  Text,
} from "@kiwicom/orbit-components";

import { Reload } from "@kiwicom/orbit-components/icons";
import DriverItem from "../components/DriverItem";

const DriversGrid = () => {
  const [drivers, setDrivers] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  const populateDocs = (docs) => {
    if (docs === undefined) return setLoading(false);
    setLastDoc(docs[docs.length - 1]);

    let data = [];

    docs.forEach((doc) => {
      data.push({ ...doc.data(), ref: doc.ref });
    });

    setDrivers((prevData) => [...prevData, ...data]);
    setLoading(false);
  };

  const removeDriverFromList = (driver) => {
    setLoading(true);
    const ind = drivers.indexOf(driver);
    console.log(`index of the driver is: ${ind}`);
    if (ind > -1) {
      setDrivers(drivers.filter((item) => item !== driver));
      console.log("Driver removed from the list");
    }
    setLoading(false);
  };

  const getDriversOnInit = () => {
    setLoading(true);
    fetchDrivers(lastDoc).then(
      (result) => {
        populateDocs(result);
      },
      (_) => setLoading(false)
    );
  };

  useEffect(() => getDriversOnInit(), []);

  return !loading ? (
    <Stack direction="column">
      <Heading>Approve Delivery Executives</Heading>
      <Grid
        largeDesktop={{ columns: "repeat(3, 1fr)" }}
        mediumMobile={{ columns: "repeat(2, 1fr)" }}
        rowGap="1.5rem"
        columnGap="1rem"
      >
        {drivers.length === 0 && <Text>No Executives </Text>}
        {drivers.length !== 0 &&
          drivers.map((eachDriver) => (
            <DriverItem
              key={eachDriver.id}
              driver={eachDriver}
              removeDriverFromList={() => removeDriverFromList(eachDriver)}
            />
          ))}
      </Grid>
      {drivers.length > 3 && (
        <Box padding={{ bottom: "XXLarge" }}>
          <Button
            iconLeft={<Reload />}
            type="secondary"
            onClick={() => getDriversOnInit()}
            spaceAfter="largest"
          >
            Load More
          </Button>
        </Box>
      )}
    </Stack>
  ) : (
    <Loading type="pageLoader" />
  );
};

export default DriversGrid;
